/**
 * @module websocket.event.handlers.baggages.baggage-deleted
 */
import { store } from '../../../../state/store'
import { setBaggageListUpdated } from '../../../../state/websocket.slice'

export default function handleBaggageDeleted(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleBaggageDeleted', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setBaggageListUpdated(data))
  }
} 